import TitleBox from '@/molecules/titles/TitleBox';
import { SIZE } from '@/types/utils';
import { useMediaQuery } from '@react-hookz/web';
import clx from 'classnames';
import { EDITO_WIDGET_X_PADDING } from 'components/widgets/const';
import { useState } from 'react';
import { CMSCallToActionType, CmsImageType } from 'utils/cms/types';
import PlayDesktop from './Playdesktop';
import PlayMobile from './PlayMobile';

type VideoItemType = {
  lazyload_cta: boolean;
  video_url: string;
  video_title: string;
  video_type: 'mp4' | 'vimeo' | 'youtube';
  video_poster?: CmsImageType;
  cta?: CMSCallToActionType;
  title?: string;
};

type VideoBlockBlockProps = {
  videos: VideoItemType[];
};

const VideoItem = ({
  video_type: videoType,
  video_url: videoUrl,
  video_title: videoTitle,
  video_poster: videoPoster,
  lazyload_cta: lazyloadCta,
  title,
  cta,
}: VideoItemType) => {
  const [clicked, setClicked] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)', { initializeWithValue: false });

  if (lazyloadCta && !clicked) {
    return (
      <div>
        {!!title && (
          <TitleBox
            buttonProps={
              cta?.link
                ? { href: cta.link.url, children: cta.link.title, variant: cta.variant, size: SIZE.SM, icon: cta.icon }
                : undefined
            }
          >
            {title}
          </TitleBox>
        )}
        <div className="relative w-fit">
          <img alt="" src={videoPoster?.url} />
          <button
            className="group absolute w-fit left-0 right-0 m-auto bottom-0 top-0 drop-shadow-xl"
            onClick={() => setClicked(true)}
            type="button"
          >
            {isMobile ? <PlayMobile /> : <PlayDesktop />}
          </button>
        </div>
      </div>
    );
  }

  if (videoType === 'mp4') {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <video
        className="aspect-video"
        height="100%"
        poster={videoPoster?.url}
        preload="metadata"
        width="100%"
        controls
        playsInline
      >
        <source src={videoUrl} type="video/mp4" />
      </video>
    );
  }

  return (
    <iframe
      key={videoTitle}
      allow="autoplay; fullscreen; picture-in-picture"
      className="aspect-video"
      height="100%"
      src={videoUrl}
      title={videoTitle}
      width="100%"
      allowFullScreen
    />
  );
};

const VideosBlockWidget = ({ videos }: VideoBlockBlockProps) => (
  <ul className={clx('grid grid-cols-1 md:grid-flow-col auto-cols-fr gap-4', EDITO_WIDGET_X_PADDING)}>
    {videos.map((video) => (
      <li key={video.video_title}>
        <VideoItem {...video} />
      </li>
    ))}
  </ul>
);

export default VideosBlockWidget;
